<div class="banner" [ngClass]="{'red': severity === 'red', 'yellow': severity === 'yellow'}">
    <span><i class="fas fa-info-circle" style="font-size: 24px; vertical-align: middle; color: var(--profile-main-color); margin-right: 1rem;"></i></span>
    <span class="brodtext-medium-14">{{text}}</span>
</div>
